const instaData = [
    {
        link: "https://i.imgur.com/gGvyVHl.jpeg"
    },
    {
        link: "https://i.imgur.com/dVFvPxU.jpeg"
    },
    {
        link: "https://i.imgur.com/NwIxtwU.jpeg"
    },
    {
        link: "https://i.imgur.com/pBicgiO.jpeg"
    },
    {
        link: "https://i.imgur.com/Lk68pr0.jpeg"
    },
    {
        link: "https://i.imgur.com/SNyl4HL.mp4"
    },
    {
        link: "https://i.imgur.com/RhAjK1K.jpeg"
    },
    {
        link: "https://i.imgur.com/Jxex9Ep.jpeg"
    },
    {
        link: "https://i.imgur.com/J8u6yHl.jpeg"
    },
    {
        link: "https://i.imgur.com/E6NcUD5.mp4"
    },
    {
        link: "https://i.imgur.com/z6vuoCE.mp4"
    },
    {
        link: "https://i.imgur.com/9hgsTqt.jpeg"
    },
    {
        link: "https://i.imgur.com/RkrHKMz.mp4"
    },
    {
        link: "https://i.imgur.com/VwPJa9P.mp4"
    },
    {
        link: "https://i.imgur.com/8Unug0e.jpeg"
    },
    {
        link: "https://i.imgur.com/WE6nvtj.mp4"
    },
    {
        link: "https://i.imgur.com/xjpPuPd.jpeg"
    },
    {
        link: "https://i.imgur.com/Szg8WV9.mp4"
    },
    {
        link: "https://i.imgur.com/flicb1Z.jpeg"
    },
    {
        link: "https://i.imgur.com/6U0dc1k.jpeg"
    },
    {
        link: "https://i.imgur.com/9URygtx.jpeg"
    },
    {
        link: "https://i.imgur.com/6QkKJHU.mp4"
    },
    {
        link: "https://i.imgur.com/kQnHBY4.mp4"
    },
    {
        link: "https://i.imgur.com/MxJSS5h.jpeg"
    },
    {
        link: "https://i.imgur.com/c6PG2si.jpeg"
    },
    {
        link: "https://i.imgur.com/4tQGy1q.jpeg"
    },
    {
        link: "https://i.imgur.com/v28Ef4y.jpeg"
    },
    {
        link: "https://i.imgur.com/YrGl3Mw.jpeg"
    },
    {
        link: "https://i.imgur.com/iZd6isz.jpeg"
    },
    {
        link: "https://i.imgur.com/dnzTiuJ.jpeg"
    }, 
    {
        link: "https://i.imgur.com/dnzTiuJ.jpeg"
    },
    {
        link: "https://i.imgur.com/SWI3ec7.jpeg"
    },
    {
        link: "https://i.imgur.com/nBphh34.jpeg"
    },
    {
        link: "https://i.imgur.com/NLtzTsA.jpeg"
    },
    {
        link: "https://i.imgur.com/u80Ym2x.mp4"
    },

]

export default instaData